/* Keep product and print prices independent; Shopify owns their nested relation. */
(function (scope) {
  'use strict';

  function nestItems(items) {
    const mainByToken = new Map();
    for (const item of items) {
      const props = item.properties || {};
      const token = props._config_main || props.config_main;
      if (token) {
        if (mainByToken.has(String(token))) throw new Error('De productkoppeling is niet eenduidig. Vernieuw de pagina en probeer opnieuw.');
        mainByToken.set(String(token), item);
      }
    }
    return items.map(item => {
      const props = item.properties || {};
      const token = props._config_sub || props.config_sub;
      if (!token) return item;
      const parent = mainByToken.get(String(token));
      if (!parent || String(parent.id) === String(item.id)) {
        throw new Error('De bedrukking kon niet aan het product worden gekoppeld. Vernieuw de pagina en probeer opnieuw.');
      }
      const parentId = Number(parent.id);
      if (!Number.isSafeInteger(parentId) || parentId <= 0) throw new Error('Het product kon niet worden herkend.');
      const linked = { ...item, parent_id: parentId };
      delete linked.parent_line_key;
      return linked;
    });
  }

  scope.SS_B2B_CART = Object.freeze({ nestItems });
})(typeof window === 'undefined' ? globalThis : window);
